import {logger} from "@main/helpers/logger";
import axios from "@main/axios";
import PerfectScrollbar from "perfect-scrollbar";
import {ToggleScroll} from "./toggle-scroll";

/** Класс модального окна "Преподаватель". */
class TeacherDescription {
    documentEl = document.body
    modal = document.querySelector(".js-modal-teacher");
    modalTeacherBlock = this.modal.querySelector(".js-teacher-block");
    modalTeacherImg = this.modal.querySelector(".js-teacher-img");
    modalTeacherText = this.modal.querySelector(".js-teacher-text");
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.url = this.el.dataset.url;

        this.createScrollbar();
        this.bindEventListeners();
    }

    /**
     * Прослушиваем событие клика на должность.
     *
     * @returns {void}
     */
    bindEventListeners() {
        document.addEventListener("click", (e) => {
            const btn = e.target.classList.contains("js-modal-teacher-btn") || e.target.closest(".js-modal-teacher-btn");
            if (btn) {
                e.preventDefault();
                this.updateModalContent(btn.dataset.id);
            }
        })
    }

    /**
     * Открытие модального окна.
     * Прокрутка контента кверху модала.
     *
     * @returns {void}
     */
    openModal() {
        this.modal.classList.add("shown");
        ToggleScroll.disable(this.modal);

        const title = this.modal.querySelector(".js-teacher-scroll-to-start");
        title?.scrollIntoView();
    }

    /**
     * Создание стилизованного скроллбара для модального окна.
     *
     * @returns {void}
     */
    createScrollbar() {
        this.scrollbar = new PerfectScrollbar(this.modalTeacherBlock, {
            suppressScrollX: true,
            wheelPropagation: false,
            handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
        });
    }

    /**
     * Получение описания вакансии.
     *
     * @param {string} id Получение id выбранной вакансии.
     * @returns {Promise}
     */
    getTeacherDescription = async (id) => {
        try {
            const {data} = await axios({
                url: this.url,
                method: "GET",
                params: {
                    id,
                }
            });

            return data;
        } catch (e) {
            logger.log(e);
        }
    }

    /**
     * Обновление контента модального окна.
     *
     * @returns {void}
     */
    updateModalContent = async (id) => {
        const response = await this.getTeacherDescription(id);
        const data = response.data;
        this.modalTeacherText.innerHTML = data.text;
        this.modalTeacherImg.src = data.img;
        this.openModal();
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-teachers-list").forEach((item) => new TeacherDescription(item));
});
